<div *transloco="let t; read: 'login_register.forgot_password'" class="mt-4">
  <div class="flex flex-col justify-center items-center" *ngIf="!emailSent">
    <psc-section-title
      [title]="t('title')"
      [subtitle]="t('enter_email')"
    ></psc-section-title>
    <form [formGroup]="formGroup" class="flex flex-col w-[90%] md:w-1/2 xl:w-1/4 md:shrink-0 mt-5 md:shrink-0"
          (keydown.enter)="onSubmit()">
      <psc-input type="email"
                 formControlName="email"
                 [label]="t('email')"
                 [required]="true"></psc-input>
      
      <psc-button class="pt-6 pb-4"
                  [label]="t('submit')"
                  (buttonClicked)="onSubmit()"
                  [disabled]="!formGroup.valid"
                  type="primary-blue-2"></psc-button>
    </form>
  </div>
  <div *ngIf="emailSent" class="flex justify-center items-center">
    <psc-section-title
      [title]="t('email_is_confirmed')"
      [subtitle]="t('check_email')"
    ></psc-section-title>
  </div>
</div>
